export default {
  AUTH_WITH_RMP_OTP: "AUTH_WITH_RMP_OTP",
  AUTH_WITH_RMP_TOKEN: "AUTH_WITH_RMP_TOKEN",
  AUTH_ADPRO: "AUTH_ADPRO",
  AD: "AD",
  FACEBOOK_AD: "FACEBOOK_AD",
  SEND_ANALYTICS_PAGE_VIEW: "SEND_ANALYTICS_PAGE_VIEW",
  SEND_ANALYTICS_LOGIN: "SEND_ANALYTICS_LOGIN",
  CURRENT_DASHBOARD: "CURRENT_DASHBOARD",
  LOGIN_TO_RDYNAMIC: "LOGIN_TO_RDYNAMIC",
  CHECK_APP_AVAILABLE: "CHECK_APP_AVAILABLE",
  GET_NEXUS_USER_INFO: "GET_NEXUS_USER_INFO",
};
